module.exports = __webpack_public_path__ + "img/Mindy_Elena-600h.704db68d.jpg";